import axios from "axios";
import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from 'feather-icons-react';
import { toast } from "react-toastify";
import Select from 'react-select';

class   StudentForm extends Component{

    state = {
        id : "",
        last_name : "",
        first_name : "",
        family_name : "",
        last_nameP : "",
        first_nameP : "",
        sectionclasseId : "",
        sectionId : "",
        tel : "",
        studentId : null,
        parentId : null,
        error : "",

        sections : [],
        
        isModal : false,
        title : "",
    }


    async sections(){
        var request = await axios.get('sections');
        if(request.status === 200)
            this.setState({sections : request.data})
    }
    
    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

    storeStudent = (val = null) =>{
        let student = {
                last_name : this.state.last_name,
                first_name : this.state.first_name,
                family_name : this.state.family_name,
                operation : "Editer" ,
            }
        let parent = {
                last_name : this.state.last_nameP,
                first_name : this.state.first_nameP,
                tel : this.state.tel,
                operation : "Editer" ,
            }

        let student_classe = {
            user : {
                tel : this.state.tel,
                userId : this.props.student?.user?.userId
            },
            student : {
                matricule : this.props.student?.matricule,
                status : 1,
                sectionclasseId : this.state.sectionclasseId
            }
        }

        axios.put('users_/'+this.state.parentId, parent).then((response) =>{
            axios.put('users_/'+this.state.studentId, student).then((response) =>{
                axios.put('students/'+this.props.student?.id, student_classe).then((response) =>{
                    this.props.showModal(1)
                    toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
                }).catch((error) => {
                    this.setState({
                        error : error.response.data.msg
                    })
                    toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
                })
            }).catch((error) => {
                this.setState({
                    error : error.response.data.msg
                })
                toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
            })
        }).catch((error) => {
            this.setState({
                error : error.response.data.msg
            })
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }
    
    edit=()=>  {
        this.form()
        this.sections()
    }

    form=()=>{
        this.setState({
            studentId: this.props.formData ? this.props.formData.id : "",
            parentId: this.props.formData ? this.props.formData.user?.id : "",
            first_name: this.props.formData ? this.props.formData.first_name : "",
            last_name: this.props.formData ? this.props.formData.last_name : "",
            family_name: this.props.formData ? this.props.formData.family_name : "",
            sectionId : this.props.student?.sectionclass?.sectionId || "",
            sectionclasseId : this.props.student?.sectionclass?.id || "",
            tel: this.props.formData ? (this.props.formData.user?.tel || null) : "",
            first_nameP: this.props.formData ? (this.props.formData.user?.first_name || "") : "",
            last_nameP: this.props.formData ? (this.props.formData.user?.last_name || "") : "",
            error : "",
        })
    }

    showModal = () => {
        this.setState({
            isModal : !this.state.isModal,
        })
    }

    render(){

        const selectMenuProps = {
            menuPortalTarget: typeof document !== "undefined" ? document.body : null,
            menuPosition: "fixed",
            classNamePrefix: "student-select",
            styles: { menuPortal: (base) => ({ ...base, zIndex: 1060 }) },
        };

        let optionsections = [], optionsectionclasses = [];

        this.state.sections.map((section) => {
            optionsections.push({value : section, label :  section.entitled_section + " (" + section.short_entitled_section + ")"})
        })

        if(this.state.sectionId && optionsections.length > 0)
        {
            if(this.state.sections.filter(dat => dat.id == this.state.sectionId).length > 0 )
            {
                this.state.sections.filter(dat => dat.id == this.state.sectionId)[0].sectionclasses.map((sectionclasse) =>{
                    optionsectionclasses.push({value : sectionclasse.id, label : sectionclasse.class.short_entitled_class + "  "+ sectionclasse.title})
                })
            }
        }

        return(
            <div>
            <Modal
                show={this.props.isModal} 
                onHide={this.props.showModal}
                size="lg"
                onEntered={this.edit}
                backdrop={"static"}
                dialogClassName="schoolfee-student-dialog"
                contentClassName="ev-form-modal schoolfee-student-modal">
                <Modal.Header>
                    <div className="ev-form-heading"><span className="ev-form-heading__icon"><FeatherIcon icon="user" size={18} /></span><div><span className="ev-form-heading__eyebrow">Identite</span><Modal.Title>Modification eleve et parent</Modal.Title></div></div>
                </Modal.Header>
                    <Modal.Body className="row ev-form-body schoolfee-student-body">
                        <div className="col-12">{ this.state.error && <div className="ev-form-alert"><FeatherIcon icon="alert-circle" size={14} /> { this.state.error }</div> }</div>
                        
                       <div className="row">
                            <div className="form-group col-md-7 mt-3">
                                <label>Section<span className="text-danger">*</span></label>
                                <Select {...selectMenuProps} className="form-control form-control-sm p-0" value={optionsections.filter(option => option.value.id === this.state.sectionId)} onChange={(select) => this.setState({ sectionId: select.value.id, sectionclasseId: "" })} options={optionsections} />
                            </div>
                            <div className="form-group col-md-5 mt-3">
                                <label>Classe affectée<span className="text-danger">*</span></label>
                                <Select {...selectMenuProps} className="form-control form-control-sm p-0" value={optionsectionclasses.filter(option => option.value === this.state.sectionclasseId)} onChange={(select) => this.setState({ sectionclasseId: select.value })} options={optionsectionclasses} />
                            </div>
                       </div>

                        <div className="col-md-4 mt-2 mt-2">
                            <div className="form-group">
                                <label htmlFor="nom-id-icon">Nom eleve</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm" placeholder=""  onChange={this.handleInput} name="last_name"  value={this.state.last_name} id="nom-id-icon" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-2 mt-2">
                            <div className="form-group">
                                <label htmlFor="nom-id-icon">Post nom</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm" placeholder=""  onChange={this.handleInput} name="family_name"  value={this.state.family_name} id="nom-id-icon" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-2 mt-2">
                            <div className="form-group">
                                <label htmlFor="nom-id-icon">Prenom eleve</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm" placeholder=""  onChange={this.handleInput} name="first_name"  value={this.state.first_name} id="nom-id-icon" />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 mt-2 mt-2">
                            <div className="form-group">
                                <label htmlFor="nom-id-icon">Nom parent</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm" placeholder=""  onChange={this.handleInput} name="last_nameP"  value={this.state.last_nameP} id="nom-id-icon" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-2 mt-2">
                            <div className="form-group">
                                <label htmlFor="nom-id-icon">Post nom parent</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm" placeholder=""  onChange={this.handleInput} name="family_nameP"  value={this.state.family_nameP} id="nom-id-icon" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-2 mt-2">
                            <div className="form-group">
                                <label htmlFor="nom-id-icon">Telephone parent</label>
                                <div className="position-relative mt-1">
                                    <input type="number" className="form-control form-control-sm" placeholder=""  onChange={this.handleInput} name="tel"  value={this.state.tel} id="nom-id-icon" />
                                </div>
                            </div>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button onClick={this.props.showModal} className="btn btn-light ev-form-button"><FeatherIcon icon="corner-down-left"></FeatherIcon> Fermer</button>
                        <button onClick={() => this.storeStudent()} className="btn btn-primary ev-form-button"><FeatherIcon icon="check-square"></FeatherIcon> Sauvegarder</button>
                    </Modal.Footer>
            </Modal>
            
 
        </div>
        )
    }
}
export default StudentForm;